module.exports = __webpack_public_path__ + "2106e7e3f0f82625a7f5e6439b2b45ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/new-desktop-bg.png
// module id = 424
// module chunks = 0